// qr-validation.enum.ts

export interface QrValidationPopup {
  heading: string;
  message: string;
  btn: string;
  navigateRoute: string | null;
  imgURL: string;
  showDismissButton?: boolean;
  rejectBtnText?: string;
}

export const QRValidationEnum: Record<string, QrValidationPopup> = {
  QR_CODE_REQUIRED: {
    heading: 'QR code scanning required to clock-in',
    message:
      'This facility requires you to scan a QR code to ensure that you are physically present to start your shift. Please request the QR code on site and scan it.',
    btn: 'Scan QR Code',
    navigateRoute: null,
    imgURL: 'assets/images/qr_code.png',
    rejectBtnText: 'Cancel'
  },

  QR_CODE_REQUIRED_CLOCK_OUT: {
    heading: 'QR code scanning required to clock-out',
    message:
      'This facility requires you to scan a QR code to ensure that you are physically present to end your shift. Please request the QR code on site and scan it.',
    btn: 'Scan QR Code',
    navigateRoute: null,
    imgURL: 'assets/images/qr_code.png',
    rejectBtnText: 'Cancel'
  },

  CAMERA_ACCESS_FAILURE: {
    heading: 'Error',
    message: 'Unable to access the camera. Please check your permissions and try again.',
    btn: 'Dismiss',
    navigateRoute: null,
    imgURL: 'assets/images/error.png',
  },

  CAMERA_NOT_FOUND: {
    heading: 'Error',
    message: 'Camera access is denied. Please enable camera permissions in your device settings.',
    btn: 'Dismiss',
    navigateRoute: null,
    imgURL: 'assets/images/error.png',
  },

  PERMISSION_DENIED: {
    heading: 'Error',
    message:
      'Camera access is denied. Please enable camera permissions in your device settings.',
    btn: 'Dismiss',
    navigateRoute: null,
    imgURL: 'assets/images/error.png',
  },

  INVALID_QR_CODE: {
    heading: 'Error',
    message:
      'The QR code you scanned has expired. Please request the updated QR code from facility staff.',
    btn: 'Scan Again',
    navigateRoute: null,
    imgURL: 'assets/images/error.png',
  },
} as const;
